import { render, staticRenderFns } from "./StavkeRezervniDelovi.vue?vue&type=template&id=173728b8&"
import script from "./StavkeRezervniDelovi.vue?vue&type=script&lang=ts&"
export * from "./StavkeRezervniDelovi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports